<template>
  <div class="button" @click="emit('click')">
    <div class="image-wrapper">
      <img :src="imgSrc" :alt="title" />
    </div>

    <h4 class="text">{{ title }}</h4>

    <p class="text">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  imgSrc: string;
  title: string;
  description: string;
}>();

const emit = defineEmits<{ (event: "click"): void }>();
</script>

<style scoped lang="sass">
.button
  background: #FEFEFE
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1)
  border-radius: 8px
  border: 1px solid transparent
  user-select: none
  cursor: pointer
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  width: 280px
  height: 280px

  &:hover
    border-color: #1890FF
    box-shadow: 0px 0px 20px rgba(24, 144, 255, 0.2)

.text
  max-width: 190px
  text-align: center

.image-wrapper
  height: 100px
  margin-bottom: 10px
  display: grid
  place-content: center

img
  height: 80px

h4
  font-weight: 600

p
  color: $gray-8
  font-size: 12px
</style>
